import i18nFactory from '@yandex-int/i18n';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { showNoticeMessage } from '../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { NoticeType } from '../../typings/grid';
import { State } from '../../typings/state';
import { VideoCreatorApiMethodExecutor } from '../api/VideoCreatorApi';
import { changeVideoCreatorImage } from '../VideoCreatorEditPage/actions';

import {
    hideImageUploaderLoader,
    RESET_IMAGE_UPLOADER_CHANGES,
    ResetImageUploaderChangesAction,
    UPLOAD_IMAGE_UPLOADER_IMAGE,
    UploadImageUploaderImageAction,
    uploadImageUploaderImageSuccess
} from './actions';
// tslint:disable-next-line no-external-i18n-import
import * as keyset from './VideoCreatorImageUploader.i18n';

const i18n = i18nFactory(keyset);

const uploadImageUploaderImageEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(UPLOAD_IMAGE_UPLOADER_IMAGE),
        switchMap(
            (action: UploadImageUploaderImageAction): Observable<Action> => {
                const { files, paramsId } = action;
                const {
                    commonData: {
                        client: { ClientID = '' }
                    }
                } = store$.value;
                const api = new VideoCreatorApiMethodExecutor();

                return from(api.uploadImage(ClientID, files[0])).pipe(
                    mergeMap(
                        (response): Observable<Action> => {
                            const { url } = response;

                            return from([
                                uploadImageUploaderImageSuccess(url, paramsId),
                                changeVideoCreatorImage(url, paramsId),
                                hideImageUploaderLoader(paramsId)
                            ]);
                        }
                    ),
                    catchError(() => {
                        showNoticeMessage(NoticeType.error, i18n('upload-error'));

                        return of(hideImageUploaderLoader(paramsId));
                    })
                );
            }
        )
    );
};

const resetImageUploaderImageEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
): Observable<Action> => {
    return action$.pipe(
        ofType(RESET_IMAGE_UPLOADER_CHANGES),
        switchMap(
            (action: ResetImageUploaderChangesAction): Observable<Action> => {
                const { resourcesId } = action;
                const { imageUploaderEditor } = store$.value;

                return of(changeVideoCreatorImage(imageUploaderEditor[resourcesId].sourceImageUrl, resourcesId));
            }
        )
    );
};

export const videoCreatorImageUploaderEpics = combineEpics(uploadImageUploaderImageEpic, resetImageUploaderImageEpic);
